import React from 'react';
import {
  Flex,
  useColorMode,
  useIsMobileView,
  Text,
  color,
  typography,
  Link,
} from 'deepstash-ui';
import { CollectionApiResponse } from 'api/api.types';
import NextImage from 'src/components/image/NextImage';
import NextLink from 'src/components/navigation/NextLink';
import { slugify } from 'utils/global';
import { useRouter } from 'next/router'; // Use it instead of own useRouter for fixing scroll problems

const COLLECTION_IMAGE_SIZE = { WIDTH: 200, HEIGHT: 300, BORDER_RADIUS: 16 };

const TITLE = 'Similar Collections';

interface CollectionSimilarCollectionsSectionProps {
  similarCollections: CollectionApiResponse[];
}

const CollectionSimilarCollectionsSection: React.FC<
  CollectionSimilarCollectionsSectionProps
> = ({ similarCollections }) => {
  const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();
  const router = useRouter();

  const renderCollectionsCarousel = () => {
    return (
      <Flex
        flexDirection="column"
        gridRowGap={16}
        mt={32}
        width={'100%'}
        overflow="hidden"
        // justifyContent={isMobileView ? 'flex-start' : 'center'}
      >
        <Flex
          width={'100%'}
          flexDirection="row"
          gridColumnGap={16}
          {...(isMobileView ? { overflow: 'scroll', px: 16, pb: 16 } : {})}
          justifyContent={isMobileView ? 'flex-start' : 'center'}
        >
          {similarCollections.map((collection, index) => {
            const collectionSlug = slugify(collection.name);
            const collectionPageRoute = `/collection/${collection.id}/${collectionSlug}`;
            return (
              <Flex
                key={index}
                w={200}
                flexDirection="column"
                gridRowGap={16}
                alignItems="center"
              >
                <NextImage
                  wrapperStyle={{
                    width: COLLECTION_IMAGE_SIZE.WIDTH,
                    height: COLLECTION_IMAGE_SIZE.HEIGHT,
                    borderRadius: COLLECTION_IMAGE_SIZE.BORDER_RADIUS,
                    cursor: 'pointer',
                  }}
                  imageUrl={collection.image}
                  blurhash={collection.image_blurhash}
                  alt={`${collection.name}`}
                  priority={false}
                  onClick={() => {
                    router.push(collectionPageRoute);
                  }}
                />
                <NextLink
                  href={collectionPageRoute}
                  passHref
                  key={`book-${index}`}
                >
                  <Link _focus={undefined} _hover={undefined}>
                    <Text
                      textAlign="center"
                      {...typography.primaryHeadingFonts.small.regular}
                      color={color[colorMode].text}
                    >{`${collection.name}`}</Text>
                  </Link>
                </NextLink>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    );
  };

  return (
    <Flex
      flexDirection="column"
      width={'100%'}
      alignItems="center"
      mt={isMobileView ? 32 : 128}
    >
      <Text
        {...(isMobileView
          ? typography.primaryHeadingFonts.small.bold
          : typography.primaryHeadingFonts.large.bold)}
        color={color[colorMode].text}
        textAlign="center"
      >
        {TITLE}
      </Text>
      {renderCollectionsCarousel()}
    </Flex>
  );
};

export default CollectionSimilarCollectionsSection;
